import { createStore, applyMiddleware, compose } from 'redux';

// Пакет remote-redux-devtools работает только при process.env.NODE_ENV === 'development'
// В текущем варианте - после запуска npm start в соседней вкладке открываем http://remotedev.io/local/

import { composeWithDevTools } from 'remote-redux-devtools';

import createSagaMiddleware from 'redux-saga';
import sagas from './rootSaga';
import rootReducer from './rootReducer';
import { redirectMiddleware } from '../common/middlewares/redirect';

const createAppStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  // Если установлено расширение браузера: composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  // Если используется библиотека remote-redux-devtools: composeEnhancers = composeWithDevTools
  // Если отладка не нужна: composeEnhancers = compose
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ||
    composeWithDevTools ||
    compose;

  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware, redirectMiddleware))
  );

  sagaMiddleware.run(sagas);

  return store;
};

export default createAppStore;
